import { BrowserRouter, Routes, Route } from "react-router-dom";
import DnDContextProvider from './context/dndContext';
import PageTreeContextProvider from './context/pageTreeContext';
import MCQuiz from './components/multipleChoice/MCQuiz';
import VideoFlipCard from './components/FlipCard/videoFlipCard';
import Navbar from './components/Navbar/Navbar_test';
import Login from './components/Login/login';
import Lerneinheiten from './components/Lerneinheiten/index';
import Page from './components/Page/index';
import TechIntro from "./components/Page/techIntroPage"
import ContentIntro from "./components/Page/contentIntroPage"
import FavoritePages from "./components/Favorites/favoritePages"
import ErfahrenSieMehr from "./components/ErfahrenSieMehr"
import {Layout} from './components/Layout/layout';
import StartPage from "./components/StartPage/StartPage"
import "./App.css"
import Impressum from "./components/Impressum"
import Datenschutz from "./components/Datenschutz"
import {basename } from "./constants"

function App() {
  return (
    <div className="App">
      <PageTreeContextProvider>
        <BrowserRouter
          // basename not neccessary for local development 
          basename={basename}
        >
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/start" element={<Layout><StartPage /></Layout>} />
                <Route path="lerneinheiten" element={<Layout><Lerneinheiten /></Layout>} />
                <Route path="lerneinheiten/page/:id" element={<Layout><Page /></Layout>} /> 

                <Route path="technische-einfuehung" element={<Layout><TechIntro /></Layout>} /> 
                <Route path="inhaltliche-einfuehrung" element={<Layout><ContentIntro /></Layout>} /> 
                <Route path="favorites/pages" element={<Layout><FavoritePages /></Layout>} /> 

                <Route path="impressum" element={<Layout><Impressum /></Layout>} /> 
                <Route path="datenschutz" element={<Layout><Datenschutz /></Layout>} /> 

                <Route path="info" element={<Layout><ErfahrenSieMehr /></Layout>} /> 
                
            </Routes>
        </BrowserRouter>
      </PageTreeContextProvider>
    </div>
  );
}

export default App;
